import {createFileRoute} from '@tanstack/react-router'
import {secondLevelLayoutRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName')({
    ...secondLevelLayoutRoute()
});
